import { ButtonHTMLAttributes, PropsWithChildren } from 'react'

export default function OutlinedButton({
  children,
  className,
  ...props
}: PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>>): JSX.Element {
  return (
    <button className={`py-3 px-7 border-2 border-light-green rounded-xl text-main ${className ?? ''}`} {...props}>
      {children}
    </button>
  )
}
